export default __webpack_public_path__ + "static/media/room1.9cf73c1a.jpg";